import { render, staticRenderFns } from "./EffectMenuToggle.vue?vue&type=template&id=2380e298&scoped=true&"
import script from "./EffectMenuToggle.vue?vue&type=script&lang=js&"
export * from "./EffectMenuToggle.vue?vue&type=script&lang=js&"
import style0 from "./EffectMenuToggle.vue?vue&type=style&index=0&id=2380e298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2380e298",
  null
  
)

export default component.exports